import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const adminApi = axios.create({ baseURL: API });
export const portalApi = axios.create({ baseURL: API });

adminApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("vs_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

portalApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("vs_customer_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Etwas ist schiefgelaufen.";
}
